import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import InvoiceSkeleton from "../../components/Reusable/InvoiceSkeleton";
import SwitchTab from "../../components/Reusable/SwitchTab";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
const InvoicePreviewComponent = loadable(
  () => import("../../components/MerchantInvoice/CargoInvoicePreview")
);
const CargoMerchantInvoicePreview = () => {
  const { id } = useParams();

  const { data: order, isLoading } = useGetHook({
    queryKey: ["merchant-invoice", `merchant-inovice-${id}`],
    url: `${APIS.MERCHANT_INVOICE}${id}/`,
    params: {},
  });

  return (
    <>
      <SwitchTab id={id} />
      {isLoading ? (
        <InvoiceSkeleton />
      ) : (
        <InvoicePreviewComponent order={order} id={id} />
      )}
    </>
  );
};

export default CargoMerchantInvoicePreview;
